'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRepoForcePush = function GoRepoForcePush(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 2.5c0-1.2-1.2-2.5-2.5-2.5h-25s-2.5 1.3-2.5 2.5v30s0-1.2 0 0 1.3 2.5 2.5 2.5h5v5l5-5v-5h-5v2.5h-3.7s-1.3-0.6-1.3-1.2v-3.8h10v-2.5h-5v-22.5h20v22.5h-5v2.5h5v3.8s-0.6 1.2-1.2 1.2h-3.8v2.5h5s2.5-1.2 2.5-2.5v-30z m-10.6 12.5h5.6l-7.5-10-7.5 10h5.6l-5.6 7.5h5v17.5h5v-17.5h5l-5.6-7.5z' })
        )
    );
};

exports.default = GoRepoForcePush;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/repo-force-push.js
// module id = 1977
// module chunks = 0